import {AccountFieldsPrefix, withPrefix} from '@/constants/prv-comp';
import {DocumentData} from '@/engine';
import {AccountPac, AccountPacInvestmentInstructions} from '@/types/client-info';
import {COMP_TO_PAC_MAPPINGS} from './comp-to-pac-mappings';
import {findIndexedValuesInStore, reorderItemsByKey} from './reorder-items-by-key';

const reorderInstructions = (
  oldStoreData: DocumentData['data'],
  instructions: AccountPacInvestmentInstructions,
  prefix: AccountFieldsPrefix,
): AccountPacInvestmentInstructions =>
  COMP_TO_PAC_MAPPINGS.reduce(
    (result, {compKeyField, investmentType, getKey}) => ({
      ...result,
      [investmentType]: reorderItemsByKey(
        findIndexedValuesInStore(oldStoreData, withPrefix(compKeyField, prefix)),
        instructions[investmentType],
        getKey,
      ),
    }),
    instructions,
  );

export const reorderPacs = (
  oldStoreData: DocumentData['data'],
  freshPacs: AccountPac[],
  prefix: AccountFieldsPrefix,
): AccountPac[] => {
  if (freshPacs.length !== 1) return freshPacs;

  const [pac] = freshPacs;

  return [{...pac, investmentInstructions: reorderInstructions(oldStoreData, pac.investmentInstructions, prefix)}];
};

export const reorderAccountPacs = <T extends {pac: AccountPac[] | null}>(
  account: T,
  oldStoreData: DocumentData['data'],
  prefix: AccountFieldsPrefix,
): T => (account.pac ? {...account, pac: reorderPacs(oldStoreData, account.pac, prefix)} : account);
